import o from "react";
import { useTheme as m, Button as n, Icon as a } from "@mui/material";
function u(t) {
  const e = m();
  return /* @__PURE__ */ o.createElement(
    n,
    {
      sx: {
        color: e.palette.typography.mediumEmphasis,
        "&:hover": {
          color: e.palette.typography.mediumEmphasis
        }
      },
      ...t
    },
    t.icon && /* @__PURE__ */ o.createElement(a, null, t.icon)
  );
}
export {
  u as B
};
